<div class="sd-container sd-container--variant-white">
  <div class="sd-headline sd-headline--size-3xl">{{ 'profile.notificationSettings.title' | transloco }}</div>
  <div class="header-line"></div>

  <p>{{ 'profile.notificationSettings.subtitle' | transloco }}</p>
  <wct-spacer [spacingAmount]="2"></wct-spacer>

  <div class="sd-leadtext sd-leadtext--size-lg">
    {{ 'profile.notificationSettings.reportSubscriptions' | transloco }}
  </div>
  <div class="header-line"></div>

  <ng-template
    [wctApiCall]="settings"
    [apiCallAdditionalLoading]="loading">
    <sd-4-5-1-select
      (sd-change)="onNotificationChanged($event)"
      [value]="settings"
      [sd-value-injector]="settings"
      [disabled]="settings() && !loading() ? null : true"
      [placeholder]="'profile.notificationSettings.placeholder' | transloco">
      @for (notificationSetting of notificationSettings; track $index) {
      <sd-4-5-1-option [value]="notificationSetting">
        {{ notificationSetting | prefix : 'profile.notificationSettings' | transloco }}
      </sd-4-5-1-option>
      }
    </sd-4-5-1-select>
  </ng-template>
</div>
